// extracted by mini-css-extract-plugin
export var cssAnimation = "Modal-module--cssAnimation--974d3";
export var fadeIn = "Modal-module--fadeIn--434d3";
export var modalBackground = "Modal-module--modalBackground--b01b2";
export var modalBackground2 = "Modal-module--modalBackground2--d9578";
export var modalBackgroundToolTip = "Modal-module--modalBackgroundToolTip--1f20f";
export var modalBackgroundToolTipShow = "Modal-module--modalBackgroundToolTipShow--3b741";
export var modalBackgroundTooltip = "Modal-module--modalBackgroundTooltip--f1fd2";
export var modalBody = "Modal-module--modalBody--40bb3";
export var modalBodyRecalc = "Modal-module--modalBodyRecalc--29086";
export var modalContainer = "Modal-module--modalContainer--04aeb";
export var modalContainer2 = "Modal-module--modalContainer2--cb06b";
export var modalContainer3 = "Modal-module--modalContainer3--c3c98";
export var modalTitle = "Modal-module--modalTitle--bb316";
export var slideUp = "Modal-module--slide-up--8cb3b";
export var spin = "Modal-module--spin--4a30e";
export var spinnerContainer = "Modal-module--spinnerContainer--53c84";
export var spinnerImg = "Modal-module--spinnerImg--0d3b3";
export var textContainer = "Modal-module--textContainer--ad063";
export var titleCloseBtn = "Modal-module--titleCloseBtn--8e568";
export var tooltipModalContainer = "Modal-module--tooltipModalContainer--d2678";
export var x = "Modal-module--x--7dda0";